import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import Avatar from 'react-avatar-editor';

import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import Loading from './loading';

import {
    BlueCloseIcon,
    BlueTickIcon,
    TypeCameraIcon,
    RotateIcon,
} from '../../images/icons/WrapSvg';

function getImageDimensions(file) {
    return new Promise(function(resolved, rejected) {
        var i = new Image();
        i.onload = function() {
            resolved(i);
        };
        i.src = file;
    });
}

async function generateThumbnail(src) {
    var img = await getImageDimensions(src);
    var oc = document.createElement('canvas'),
        octx = oc.getContext('2d');
    oc.width = img.width;
    oc.height = img.height;
    octx.drawImage(img, 0, 0);
    while (oc.width * 0.5 > 128) {
        oc.width *= 0.5;
        oc.height *= 0.5;
        octx.drawImage(oc, 0, 0, oc.width, oc.height);
    }
    oc.width = 128;
    oc.height = (oc.width * img.height) / img.width;
    octx.drawImage(img, 0, 0, oc.width, oc.height);
    return oc.toDataURL('image/jpeg');
}

class AvatarDialog extends React.Component {
    state = {
        src: undefined,
        loading: false,
        rotate: 0,
    };

    handleChange(e) {
        this.setState({ src: e.target.files[0] });
    }

    handleRotate = (event) => {
        this.setState({ rotate: (this.state.rotate + 90) % 360 });
    };

    handleClose = (action) => {
        if (action && this.state.src) {
            const canvas = this.editor.getImage().toDataURL();
            generateThumbnail(canvas).then(async (thumbnail) => {
                this.props.handleClose(thumbnail);
            });
        } else {
            this.props.handleClose();
        }
    };

    setEditorRef = (editor) => (this.editor = editor);

    render() {
        const { fullScreen } = this.props;
        const { src, rotate, loading } = this.state;
        if (loading) {
            return <Loading open opacity />;
        } else {
            return (
                <div>
                    <Dialog
                        open={this.props.open}
                        fullScreen={fullScreen}
                        onClose={() => this.handleClose()}
                        aria-labelledby="responsive-dialog-title"
                        className={'z_index_dialog'}
                    >
                        <div
                            className="flex_full_column height100 width100"
                            style={{ backgroundImage: `url(${src})` }}
                        >
                            <div className="flex_auto_row opacity">
                                <BlueCloseIcon
                                    className={'c_white margin_top_18 margin_left_18 hand'}
                                    onClick={() => this.handleClose()}
                                />
                                <div className="flex_full_row elements_from_right">
                                    <BlueTickIcon
                                        className={'c_white margin_top_18 margin_right_18 hand'}
                                        onClick={() => this.handleClose(true)}
                                    />
                                </div>
                            </div>
                            <div className="flex_full_column padding_borders opacity center">
                                <div className={'flex_auto_row margin_top_9 margin_bottom_12'}>
                                    <div className="upload-btn-wrapper ">
                                        <button className="btn bg_ice_blue">
                                            <TypeCameraIcon
                                                width={16}
                                                heigth={16}
                                                color={'primary'}
                                            />
                                        </button>
                                        <input
                                            type="file"
                                            onChange={this.handleChange.bind(this)}
                                            multiple={false}
                                        />
                                    </div>
                                    <div className="upload-btn-wrapper ">
                                        <button className="btn bg_ice_blue">
                                            <RotateIcon
                                                width={16}
                                                heigth={16}
                                                color={'primary'}
                                                onClick={this.handleRotate}
                                            />
                                        </button>
                                    </div>
                                </div>

                                <Avatar
                                    ref={this.setEditorRef}
                                    image={src}
                                    width={250}
                                    height={250}
                                    border={50}
                                    borderRadius={255}
                                    color={[255, 255, 255, 0.6]}
                                    rotate={rotate}
                                    className={'flex_auto_row'}
                                />
                            </div>
                        </div>
                    </Dialog>
                </div>
            );
        }
    }
}

AvatarDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
};

AvatarDialog = injectIntl(AvatarDialog);

export default withMobileDialog()(AvatarDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/Avatar.js